import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type ModelAssignmentSaveFailedAction = {
	type: 'MODEL_ASSIGNMENT_SAVE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): ModelAssignmentSaveFailedAction => ({
	type: 'MODEL_ASSIGNMENT_SAVE_FAILED',
	payload,
});
